import {useState} from "react"

export default function useAccordionList(args: {numOfItems: number; allowMultipleExpanded: boolean}) {
	const {numOfItems, allowMultipleExpanded} = args
	const [expandedIndices, setExpandedIndices] = useState(Array<boolean>(numOfItems).fill(false))

	function handleExpand(index: number) {
		setExpandedIndices((prev) => {
			const newExpandedIndices = [...prev]
			if (allowMultipleExpanded) {
				// Toggle the state of the clicked accordion
				newExpandedIndices[index] = !newExpandedIndices[index]
			} else {
				// If only one can be open, collapse all others and toggle the clicked one
				newExpandedIndices.fill(false)
				newExpandedIndices[index] = !prev[index]
			}
			return newExpandedIndices
		})
	}

	return {expandedIndices, handleExpand}
}
